import { authApiService } from '@/api/authApiService';
import { AddingOrgAdminStatusCodeType } from '@/api/v1/opco/organizations/getUserAddingStatusApi';
import { ApiResponseType } from '@/types/sharedTypes';

type InternalOrganizationUserAddingStatusResponseType = {
  code: AddingOrgAdminStatusCodeType;
  is_available_to_add: boolean;
};

export const getInternalOrganizationUserAddingStatusApi = async (
  userId: string
): Promise<ApiResponseType<InternalOrganizationUserAddingStatusResponseType>> => {
  const uri = `/organization/internal/users/${userId}/adding-status/`;

  return authApiService.GET(uri);
};
